export type AgentType = "planning-applications-chat" | "planning-area-overview-chat" | "local-plan-chat";

export const agentTypeFriendlyNames: Record<AgentType, string> = {
  "planning-applications-chat": "Planning Applications",
  "planning-area-overview-chat": "Planning Area Overview",
  "local-plan-chat": "Local Plan knowledge",
};
